import { Component } from '@angular/core';
import { ModalBase } from 'src/app/model/modal-base';

@Component({
    selector: 'app-nets-payment-declined-modal',
    templateUrl: 'nets-payment-declined-modal.component.html'
})
export class NetsPaymentDeclinedModalComponent extends ModalBase
{
    public constructor()
    {
        super();
    }
}
